import React from 'react';

/**
 * Treść Regulaminu korzystania z systemu Documaster Globalservice, wersja 1.0.
 * Tekst pochodzi z działu prawnego. Zmiany treści uzgadniać z działem prawnym.
 */
const TermsContent = () => <>
  <h2>Regulamin korzystania z systemu Documaster Globalservice</h2>
  <p className="legal-version">Wersja 1.0</p>

  <h3>§1. Informacje ogólne</h3>
  <p>Niniejszy Regulamin określa zasady korzystania z systemu Documaster Globalservice, zwanego dalej „Systemem”.</p>
  <p>Producentem, dostawcą oraz operatorem Systemu jest:</p>
  <p>
    Euroimpex S.A.<br/>
    ul. Mydlana 3B<br/>
    51-502 Wrocław<br/>
    dalej: „Euroimpex” lub „Operator”.
  </p>
  <p>Documaster Globalservice jest systemem służącym do zdalnego monitorowania, ewidencji i raportowania stanu urządzeń wielofunkcyjnych Ricoh oraz obsługi informacji serwisowych. Dane pochodzące z urządzeń przekazywane są do centralnego systemu utrzymywanego przez Euroimpex i prezentowane uprawnionym użytkownikom za pomocą konsoli WWW.</p>
  <p>System nie jest systemem zarządzania drukiem ani serwerem wydruku i nie obsługuje kolejek wydruku.</p>
  <p>Korzystanie z Systemu wymaga posiadania konta użytkownika oraz odpowiednich uprawnień.</p>

  <h3>§2. Dane przetwarzane przez System</h3>
  <p>Aplikacja Documaster Globalservice instalowana jest bezpośrednio na urządzeniu Ricoh w wersji Java lub Android, zależnie od platformy urządzenia. Do komunikacji z centralnym Systemem urządzenie musi posiadać dostęp do Internetu.</p>
  <p>System może zbierać i przechowywać w szczególności:</p>
  <ul>
    <li>nazwę urządzenia;</li>
    <li>numer seryjny;</li>
    <li>NIS;</li>
    <li>model;</li>
    <li>adres IP;</li>
    <li>adres MAC;</li>
    <li>lokalizację;</li>
    <li>opis urządzenia;</li>
    <li>pola własne;</li>
    <li>informacje o stanie urządzenia;</li>
    <li>liczniki;</li>
    <li>poziomy materiałów eksploatacyjnych;</li>
    <li>informacje o błędach i zdarzeniach;</li>
    <li>historię stanów;</li>
    <li>informacje dotyczące wymian materiałów eksploatacyjnych;</li>
    <li>znaczniki czasu komunikacji i zmian.</li>
  </ul>
  <p>Zakres danych urządzeń opisany jest również w dokumentacji produktu.</p>
  <p>W ramach kont użytkowników System może przetwarzać dane niezbędne do identyfikacji i uwierzytelnienia użytkownika oraz obsługi jego konta, w szczególności adres e-mail oraz informacje dotyczące nadanych uprawnień. Dokumentacja produktu potwierdza możliwość zmiany przez użytkownika hasła oraz przypisanego adresu e-mail.</p>

  <h3>§3. Użytkownicy i role</h3>
  <p>Konto w Systemie jest kontem indywidualnym.</p>
  <p>W Systemie mogą występować co najmniej następujące role:</p>
  <p>a) Administrator – użytkownik posiadający rozszerzone uprawnienia w zakresie przypisanej organizacji, lokalizacji lub lokalizacji;</p>
  <p>b) Użytkownik – użytkownik posiadający podstawowy dostęp do informacji i funkcji Systemu w zakresie wynikającym z nadanych uprawnień.</p>
  <p>Zakres dostępu może być ograniczony do określonych lokalizacji i znajdujących się w nich urządzeń.</p>
  <p>Administrator określonej lokalizacji może wykonywać czynności administracyjne wyłącznie w zakresie lokalizacji i urządzeń, do których otrzymał uprawnienia.</p>
  <p>Użytkownik nie posiada uprawnienia do usuwania danych znajdujących się w Systemie.</p>
  <p>Użytkownik nie może w szczególności usuwać:</p>
  <ul>
    <li>urządzeń;</li>
    <li>lokalizacji;</li>
    <li>danych licznikowych;</li>
    <li>historii urządzeń;</li>
    <li>danych o zdarzeniach;</li>
    <li>danych innych użytkowników;</li>
    <li>innych danych przechowywanych w Systemie.</li>
  </ul>
  <p>Zakres funkcjonalny poszczególnych ról może być zmieniany wraz z rozwojem Systemu, przy zachowaniu zasad kontroli dostępu.</p>

  <h3>§4. Obowiązki użytkownika</h3>
  <p>Użytkownik zobowiązany jest:</p>
  <ul>
    <li>korzystać z Systemu zgodnie z jego przeznaczeniem;</li>
    <li>chronić swoje dane dostępowe;</li>
    <li>nie udostępniać konta innym osobom;</li>
    <li>korzystać wyłącznie z danych i urządzeń objętych przyznanymi uprawnieniami;</li>
    <li>nie podejmować prób obejścia zabezpieczeń Systemu;</li>
    <li>zgłaszać zauważone incydenty bezpieczeństwa lub nieprawidłowości.</li>
  </ul>
  <p>Zabronione jest:</p>
  <ul>
    <li>uzyskiwanie nieautoryzowanego dostępu;</li>
    <li>podejmowanie prób zwiększenia własnych uprawnień;</li>
    <li>wykorzystywanie błędów Systemu;</li>
    <li>ingerowanie w oprogramowanie;</li>
    <li>dekompilowanie lub modyfikowanie oprogramowania, z wyjątkiem przypadków wyraźnie dozwolonych prawem;</li>
    <li>zakłócanie działania Systemu;</li>
    <li>automatyczne lub masowe pobieranie danych bez zgody Euroimpex;</li>
    <li>udostępnianie osobom nieuprawnionym danych uzyskanych z Systemu.</li>
  </ul>

  <h3>§5. Bezpieczeństwo kont</h3>
  <p>Użytkownik odpowiada za zachowanie poufności danych dostępowych do swojego konta.</p>
  <p>W przypadku podejrzenia ujawnienia hasła Użytkownik powinien niezwłocznie zmienić hasło i poinformować Administratora lub Euroimpex.</p>
  <p>Euroimpex może czasowo zablokować konto w przypadku:</p>
  <ul>
    <li>podejrzenia jego przejęcia;</li>
    <li>wykrycia nietypowej aktywności;</li>
    <li>naruszenia Regulaminu;</li>
    <li>zagrożenia bezpieczeństwa Systemu;</li>
    <li>ustania podstawy do korzystania z Systemu.</li>
  </ul>

  <h3>§6. Dostępność i komunikacja urządzeń</h3>
  <p>Prawidłowe działanie monitoringu wymaga dostępu urządzenia do Internetu.</p>
  <p>Brak aktualnych danych może wynikać między innymi z:</p>
  <ul>
    <li>wyłączenia urządzenia;</li>
    <li>braku połączenia z Internetem;</li>
    <li>problemów z siecią klienta;</li>
    <li>problemów z aplikacją urządzenia;</li>
    <li>prac serwisowych lub awarii Systemu.</li>
  </ul>
  <p>System prezentuje informacje otrzymane z urządzenia. Dostępność poszczególnych informacji może zależeć od modelu, wersji oprogramowania urządzenia oraz jego możliwości technicznych.</p>

  <h3>§7. Raportowanie</h3>
  <p>System może umożliwiać generowanie raportów dotyczących w szczególności liczników oraz historii materiałów eksploatacyjnych.</p>
  <p>System umożliwia również tworzenie cyklicznych zadań raportowych zgodnie z udostępnioną funkcjonalnością.</p>
  <p>Przed wykorzystaniem danych do rozliczeń Użytkownik powinien uwzględnić stan komunikacji urządzeń z Systemem w analizowanym okresie.</p>

  <h3>§8. Prawa do Systemu</h3>
  <p>Autorskie prawa majątkowe do oprogramowania Documaster Globalservice oraz jego elementów przysługują Euroimpex S.A. lub podmiotom, od których Euroimpex uzyskał odpowiednie prawa lub licencje.</p>
  <p>Uzyskanie dostępu do Systemu nie oznacza przeniesienia na Użytkownika jakichkolwiek praw własności intelektualnej.</p>
  <p>Użytkownik otrzymuje prawo korzystania z Systemu wyłącznie w zakresie wynikającym z umowy, przydzielonych uprawnień i niniejszego Regulaminu.</p>

  <h3>§9. Zakończenie dostępu</h3>
  <p>Dostęp do Systemu może zostać odebrany w szczególności:</p>
  <ul>
    <li>na żądanie klienta;</li>
    <li>po zakończeniu współpracy;</li>
    <li>po ustaniu uprawnień danej osoby;</li>
    <li>w przypadku naruszenia Regulaminu;</li>
    <li>ze względów bezpieczeństwa.</li>
  </ul>
  <p>Usunięcie lub zablokowanie konta Użytkownika nie oznacza automatycznego usunięcia danych technicznych urządzeń oraz ich historii.</p>

  <h3>§10. Postanowienia końcowe</h3>
  <p>Euroimpex może dokonywać zmian Regulaminu wynikających w szczególności z rozwoju Systemu, zmian funkcjonalnych, zmian bezpieczeństwa lub obowiązujących przepisów.</p>
  <p>Istotne zmiany mogą być komunikowane za pośrednictwem Systemu lub poczty elektronicznej.</p>
  <p>W sprawach nieuregulowanych Regulaminem zastosowanie mają właściwe przepisy prawa polskiego oraz postanowienia umowy zawartej z klientem.</p>
  <p className="legal-version">Regulamin obowiązuje od dnia 01.09.2026</p>
</>;

export default TermsContent;
